import axios from "axios";
import queryString from "query-string";
import Config from "../consts/config";
import { getToken, getToken_type, deleteAllCookies } from "../utils/cookieAuth";
import { refreshAccessToken } from "./refreshAccessToken";
// import { useNavigate } from "react-router-dom";

const axiosClient = axios.create({
  baseURL: Config.API_URL,
  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
  const token = getToken();
  const token_type = getToken_type();
  if (token) {
    config.headers.Authorization = `${token_type} ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      // const history = useNavigate();

      const access_token = await refreshAccessToken()
        .then((res) => res)
        .catch((err) => {
          // history.push("/sign-in");
        });

      axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
      return axiosClient(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
